import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'SMS_MARKET_ALL',
        delete: 'SMS_MARKET_DELETE'
      },
      permission: {
        query: '',
        add: 'sms:market:add',
        edit: 'sms:market:edit',
        detail: '',
        remove: 'sms:market:remove',
        sms_recharge: '',
        sms_call_record: 'sms-call-record'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        width: '100px'
      }, {
        prop: 'rest',
        label: this.$t('rest'),
        width: '80px'
      }, {
        prop: 'recharge_time',
        label: this.$t('recharge_time'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.recharge_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'warn_value',
        label: this.$t('warn_value'),
        width: '180px'
      }, {
        prop: 'warn_phone',
        label: this.$t('warn_phone'),
        width: '180px'
      }, {
        prop: 'warn_is_notify',
        label: this.$t('warn_is_notify'),
        width: '180px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "warn_is_notify",
              "value": row.warn_is_notify
            }
          });
        }
      }, {
        prop: 'one_max_count',
        label: this.$t('one_max_count'),
        width: '180px'
      }, // { prop: 'is_custom', label: 'is_custom', width: '80px', render: ({ row }) => <d2-dict name="sms_market_is_custom" value={ row.is_custom } /> },
      {
        prop: 'ctime',
        label: this.$t('ctime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        width: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref2) {
        var row = _ref2.row;
        return [].concat(_toConsumableArray(_this2.p('sms_recharge', [{
          icon: 'el-icon-collection',
          label: _this2.$t('sms-recharge'),
          action: function action() {
            return _this2.goSmsRecharge(row.market_id);
          }
        }], [])), _toConsumableArray(_this2.p('sms_call_record', [{
          icon: 'el-icon-collection',
          label: _this2.$t('sms-call-record'),
          action: function action() {
            return _this2.goSmsCallData(row.market_id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goSmsRecharge: function goSmsRecharge(market_id) {
      this.closeBy(function (page) {
        return page.name === 'sms-recharge';
      });
      this.$router.push({
        name: 'sms-recharge',
        query: {
          market_id: market_id
        }
      });
    },
    goSmsCallData: function goSmsCallData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-sms-call-record';
      });
      this.$router.push({
        name: 'management-sms-call-record',
        query: {
          market_id: market_id
        }
      });
    }
  })
};